import React from 'react';

const pillars = [
  // Row 1
  {
    tag: "TRAIN",
    title: "SPORT INTENSE",
    description: "Retrouve la forme de tes 25 ans. Boxe, vélo dans les dunes, kitesurf. Repousse tes limites.",
    image: "https://images.pexels.com/photos/25975000/pexels-photo-25975000.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    tag: "DRIVE",
    title: "PURE ADRÉNALINE",
    description: "Cayenne dans le désert. Sens le rush. Rappelle-toi pourquoi tu fais tout ça.",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_c9f8c8c9-6f95-436f-97e4-46853bac1308/artifacts/vhj2bukc_pushing-the-cayenne-to.jpg",
  },
  {
    tag: "WORK",
    title: "DÉVELOPPEMENT",
    description: "Repars avec un plan d'action clair. Stratégie, IA, branding. Scale ton business.",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_c9f8c8c9-6f95-436f-97e4-46853bac1308/artifacts/xs6eu0ve_ef.jpeg",
  },
  // Row 2
  {
    tag: "NETWORK",
    title: "RÉSEAU VIVANT",
    description: "Rejoins un réseau d'entrepreneurs. Connecte-toi aux fondateurs et à tous les membres VIVANT.",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_c9f8c8c9-6f95-436f-97e4-46853bac1308/artifacts/xv25hd5r_efenke.jpg",
  },
  {
    tag: "RECOVER",
    title: "DÉTENTE",
    description: "Piscine, hammam, massage. Récupère comme un athlète pro. Recharge tes batteries.",
    image: "https://customer-assets-m6fa6gv7.emergentagent.net/job_c9f8c8c9-6f95-436f-97e4-46853bac1308/artifacts/tvldumic_Villa-Juba_Oualidia_16.jpg",
  },
  {
    tag: "EAT",
    title: "VIANDE & FEU",
    description: "Nutrition d'élite. Steaks premium, chef privé. Ton corps mérite le meilleur carburant.",
    image: "https://images.unsplash.com/photo-1508615263227-c5d58c1e5821?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxzdGVhayUyMGdyaWxsaW5nJTIwZmxhbWVzJTIwQkJRJTIwcHJlbWl1bSUyMG1lYXQlMjBmaXJlfGVufDB8fHx8MTc5MDI5NDY1NHww&ixlib=rb-4.1.0&q=85",
  },
];

const MethodSection = () => {
  return (
    <section className="bg-black py-20 md:py-28 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="font-italiana text-3xl md:text-4xl lg:text-5xl tracking-[0.1em] text-white">
            6 jours pour te <span className="text-[#D4A574]">transformer</span>
          </h2>
        </div>

        {/* Cards Grid - 3x2 - Compact */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 max-w-5xl mx-auto">
          {pillars.map((pillar, index) => (
            <div 
              key={pillar.title}
              className="group relative aspect-[5/6] rounded-xl overflow-hidden cursor-pointer"
            >
              {/* Background Image */}
              <img 
                src={pillar.image} 
                alt={pillar.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              
              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              
              {/* Content */}
              <div className="absolute inset-0 p-4 flex flex-col justify-end">
                {/* Tag */}
                <p className="text-[#D4A574] text-[9px] tracking-[0.3em] mb-1">
                  {pillar.tag}
                </p>
                
                {/* Title */}
                <h3 className="font-italiana text-base md:text-lg lg:text-xl tracking-[0.08em] text-white mb-1">
                  {pillar.title}
                </h3>
                
                {/* Description */}
                <p className="text-white/70 text-[10px] md:text-[11px] leading-relaxed line-clamp-2">
                  {pillar.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom tagline */}
        <div className="text-center mt-10">
          <p className="text-white/40 text-sm tracking-[0.2em] uppercase">
            No vegan • No limit • Just men
          </p>
        </div>
      </div>
    </section>
  );
};

export default MethodSection;
